/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState, BaseSyntheticEvent } from 'react'
import { PageTitle } from '../../../../_metronic/layout/core'
import { Datatable } from '../../../components/Datatable/Datatable'
import { Button } from '../../../components/Button/Button'

import { useNavigate } from 'react-router-dom'
import { Loading } from '../../../components/Loading/Loading'
import { DELETE, GET, POST, PUT } from '../../../services/api'
import Swal from 'sweetalert2'
import { i18n } from '../../../translate/i18n'

import { BreadCrumbs } from '../../../components/BreadCrumbs/breadCrumbrs'


enum typeBannerHotel {
  BANNER = 'banner',
  HIGHLIGHT = 'highlight',
}

interface PublicityHotel {
  id: number
  pluginspaceId: number
  image?: string
  title:string
  order: number
  startDate: string
  endDate: string
  status: boolean
  created: string
  updated: string
}

const ContaContent: FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [lojasPubli, setLojasPubli] = useState<PublicityHotel[]>([])

  const getPublicityData = async () => {
    try {
      setLoading(true)
      const res = await POST(`/publicity-hotel/filter`, {
        type:typeBannerHotel.BANNER
      })

      if (res.success && res.data) {
        // Processar dados para o formato esperado pelo Datatable
        const processedData = res.data.map((item: PublicityHotel) => ({
          ...item,
          img: item.image || '', // Para exibição na tabela
          date: new Date(item.created).toLocaleString('pt-BR'), // Formatação da data
          period: `${new Date(item.startDate).toLocaleDateString('pt-BR')} - ${new Date(item.endDate).toLocaleDateString('pt-BR')}`,
        }))

        setLojasPubli(processedData)
      } else {
        setLojasPubli([])
      }

      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.error('Erro ao carregar publicidades:', e)
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('hospitality_banner.error.title')),
        text: String(i18n.t('hospitality_banner.error.load_data')),
      })
    }
  }

  const deletePubli = async (id: number) => {
    if (!id) {
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('hospitality_banner.error.title')),
        text: String(i18n.t('hospitality_banner.error.invalid_id')),
      })
      return
    }

    // Confirmação antes de deletar
    const confirmResult = await Swal.fire({
      title: String(i18n.t('hospitality_banner.delete.confirm_title')),
      text: String(i18n.t('hospitality_banner.delete.confirm_text')),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: String(i18n.t('hospitality_banner.delete.confirm_button')),
      cancelButtonText: String(i18n.t('hospitality_banner.delete.cancel_button')),
    })

    if (!confirmResult.isConfirmed) return

    try {
      setLoading(true)
      const res = await DELETE(`/publicity-hotel/${id}`)

      if (res.success) {
        Swal.fire({
          icon: 'success',
          title: String(i18n.t('hospitality_banner.delete.success_title')),
          text: String(i18n.t('hospitality_banner.delete.success_text')),
        }).then(async () => await init())
      } else {
        throw new Error(res.message || 'Erro ao deletar publicidade')
      }

      setLoading(false)
    } catch (e: any) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('hospitality_banner.error.title')),
        text: String(e.message || i18n.t('hospitality_banner.error.delete')),
      })
      console.error('Erro ao deletar:', e)
    }
  }

  const deleteImage = async (image: string) => {
    try {
      await POST('/upload-images/delete-one', {
        url: image,
      })
    } catch (e) {
      return null
    }
  }

  useEffect(() => {
    init();
  }, [])

  const init = async () => {
    setLoading(true)
    await getPublicityData()
    setLoading(false)
  }

  const switchStatus = async (id: number, status: boolean) => {
    try {
      setLoading(true)
      const res = await PUT(`/publicity-hotel/${id}`, {
        status: !status,
      })

      if (res.success) {
        // Atualizar o estado local para refletir a mudança
        setLojasPubli(prev =>
          prev.map(item =>
            item.id === id ? { ...item, status: !status } : item
          )
        )

        Swal.fire({
          icon: 'success',
          title: String(i18n.t('hospitality_banner.status.success_title')),
          text: String(i18n.t('hospitality_banner.status.success_text', { action: !status ? i18n.t('hospitality_banner.status.activated') : i18n.t('hospitality_banner.status.deactivated') })),
          timer: 2000,
          showConfirmButton: false
        })
      } else {
        throw new Error(res.message || 'Erro ao alterar status')
      }

      setLoading(false)
    } catch (e: any) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('hospitality_banner.error.title')),
        text: String(e.message || i18n.t('hospitality_banner.error.status_change')),
      })
      console.error('Erro ao alterar status:', e)
    }
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t('hospitality_banner.page_title')}</span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t('hospitality_banner.page_subtitle')}
                </span>
              </h3>
              <div className='card-toolbar'>
                <Button
                  text={i18n.t('hospitality_banner.new_button')}
                  color='primary'
                  iconColor='#FFF'
                  icon='fas fa-plus'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => navigate('/hospitality/publicity-banner/create')}
                  btnClass='mb-5 fw-bolder'
                />
              </div>
            </div>
            <div className='card-body'>
              <Datatable
                data={lojasPubli}
                headers={[
                  { key: i18n.t('hospitality_banner.table.title'), value: 'title', type: 'default' },
                  { key: i18n.t('hospitality_banner.table.image'), value: 'img', type: 'image', noOrder: true },
                  { key: i18n.t('hospitality_banner.table.order'), value: 'order', type: 'default' },
                  { key: i18n.t('hospitality_banner.table.period'), value: 'period', type: 'default' },
                  { key: i18n.t('hospitality_banner.table.created_date'), value: 'date', type: 'default' },
                  {
                    key: i18n.t('hospitality_banner.table.status'),
                    value: 'status',
                    type: 'check',
                    action: (item) => switchStatus(item.id, item.status),
                  },
                  { key: i18n.t('hospitality_banner.table.actions'), value: 'acoes', type: '' },
                ]}
                options={[
                  {
                    icon: 'fas fa-pen',
                    title: i18n.t('hospitality_banner.actions.edit'),
                    action: (item) => {
                      navigate(`/hospitality/publicity-banner/editar/${item.id}`)
                    },
                  },
                  {
                    icon: 'fas fa-eye',
                    title: i18n.t('hospitality_banner.actions.view'),
                    action: (item) => {
                      Swal.fire({
                        title: String(i18n.t('hospitality_banner.modal.title', { id: item.id })),
                        html: `
                          <div style="text-align: left;">
                            <p><strong>${i18n.t('hospitality_banner.modal.order')}:</strong> ${item.order}</p>
                            <p><strong>${i18n.t('hospitality_banner.modal.status')}:</strong> ${item.status ? i18n.t('hospitality_banner.modal.active') : i18n.t('hospitality_banner.modal.inactive')}</p>
                            <p><strong>${i18n.t('hospitality_banner.modal.period')}:</strong> ${item.period}</p>
                            <p><strong>${i18n.t('hospitality_banner.modal.created')}:</strong> ${item.date}</p>
                            <p><strong>${i18n.t('hospitality_banner.modal.updated')}:</strong> ${new Date(item.updated).toLocaleString('pt-BR')}</p>
                            ${item.image ? `<p><strong>${i18n.t('hospitality_banner.modal.image')}:</strong></p><img src="${item.image}" style="max-width: 100%; height: 200px; object-fit: cover;" />` : `<p><strong>${i18n.t('hospitality_banner.modal.no_image')}</strong></p>`}
                          </div>
                        `,
                        width: 600,
                        showCloseButton: true,
                        showConfirmButton: false
                      })
                    },
                  },
                  {
                    icon: 'fas fa-trash',
                    action: (item) => {
                      deletePubli(item.id)
                    },
                    path: '',
                    title: i18n.t('hospitality_banner.actions.delete'),
                  },
                ]}
                color='primary'
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const PublicidadeBannerHotel: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          { title: 'Dashboard', path: 'dashboard', isActive: false },
          { title: i18n.t('hospitality_banner.breadcrumb.hospitality'), path: 'hospitality', isActive: false },
          { title: i18n.t('hospitality_banner.breadcrumb.publicity'), path: 'hospitality/publicity', isActive: true },
        ]}
      >
        {i18n.t('hospitality_banner.page_title')}
      </PageTitle>
      <ContaContent />
    </>
  )
}

export { PublicidadeBannerHotel }
